import { Spinner } from '@cloudscape-design/components';
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

interface RefreshContextProps {
  refresh: (delayMs: number) => void;
  isRefreshing: boolean;
}

const RefreshContext = createContext<RefreshContextProps | undefined>(undefined);

export const useRefresh = (): RefreshContextProps => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }
  return context;
};

export const RefreshContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const refresh = (delayMs: number) => {
    console.log(delayMs);
    if (timeoutRef.current) return; // Prevent multiple triggers
    setIsRefreshing(true);

    timeoutRef.current = setTimeout(() => {
      window.location.reload();
    }, delayMs);
  };

  // Clear timer if component unmounts
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <RefreshContext.Provider value={{ refresh, isRefreshing }}>
      {children}
      {isRefreshing && (
        <div
          style={{
            position: 'fixed',
            top: 50,
            right: 50,
            zIndex: 9999,
            padding: '8px 12px',
            background: 'rgba(0, 0, 0, 0.75)',
            color: 'white',
            borderRadius: '4px',
            transform: 'scale(2)',
          }}
        >
          <Spinner size="large" />
        </div>
      )}
    </RefreshContext.Provider>
  );
};
